import React from "react";
import {Tooltip} from "@mui/material";
import {KIND_ICON, KIND_LABEL} from "../../util/projectMembers";
import {Blue3, Grey5, Grey17} from "../../theme/styles";

/**
 * What a project holds, at a glance: five counts, each behind the kind's own icon.
 *
 * ED, 2026-10-29, on the Projects list: "add indications for the number of Products, Quote
 * Requests, Quote Response, Contracts and Build Plans" -- in that order, which is his and not the
 * strip's. The icons are the kinds' own from the classification registry, so the glyph beside a
 * count here is the one beside that kind everywhere else; the label is in the title, for a reader
 * who does not know the glyph. A zero is drawn as a zero, in a quieter ink: a folder with no
 * contracts yet is a fact worth the same width as one with three.
 */
export const CONTENT_KINDS = ["Product", "QuoteRequest", "PreparedQuote", "Contract", "BuildPlan"] as const;

export default function ProjectContents({counts}: {counts: Record<string, number> | null | undefined}) {
    return (
        <span data-testid="project-contents" style={{display: "inline-flex", alignItems: "center", gap: 12}}>
            {CONTENT_KINDS.map(kind => {
                const Icon = KIND_ICON[kind];
                const count = counts ? (counts[kind] ?? 0) : null;
                return (
                    <Tooltip key={kind} title={`${KIND_LABEL[kind]}: ${count ?? "—"}`} placement="top">
                        <span data-kind={kind} style={{display: "inline-flex", alignItems: "center", gap: 3}}>
                            {Icon && <Icon sx={{width: 15, height: 15, color: Blue3}}/>}
                            <span style={{fontSize: 12, fontVariantNumeric: "tabular-nums",
                                          color: count ? Grey17 : Grey5}}>
                                {count ?? "—"}
                            </span>
                        </span>
                    </Tooltip>
                );
            })}
        </span>
    );
}
